import React from "react";
import { useKeycloak } from "@react-keycloak/web";

const withKeycloak = (Component) => {
    return function WrappedComponent(props) {
        const { keycloak, initialized } = useKeycloak();
        return <Component {...props} keycloakInitialized={initialized} keycloak={keycloak} />
    }
}

export default withKeycloak;
